import { Component, OnInit, OnDestroy } from "@angular/core";
import { UserService } from "../../../shared/services/user.service";

import { DataService_clickoncedeploy } from "./shared/data.service";

import { wsClickOnceDeployInfo } from "./shared/wsClickOnceDeployInfo";

@Component({
	selector: "app-root",
	templateUrl: "./clickoncedeploy.component.html",
	styleUrls: ["./clickoncedeploy.component.css"],
})
export class ClickOnceDeployComponent implements OnInit, OnDestroy {
	constructor(private dataService: DataService_clickoncedeploy, private userService: UserService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;

	//	Printers List
	public lstClickOnceDeploy: wsClickOnceDeployInfo[] = [];

	public CAASSAgentDeployUrl: string = "";
	public RFIDAgentDeployUrl: string = "";
	public ScanStationDeployUrl: string = "";
	public VisitorStationDeployUrl: string = "";
	public CAASSPhotoIDDeployUrl: string = "";
	public CAASSVisitorIDDeployUrl: string = "";
	public CAASS10VisitorIDDeployUrl: string = "";
	public VPPReceiptDesignerDeployUrl: string = "";
	public MultiStationDeployUrl: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		this.isBusy = true;
		this.dataService.ClickOnceDeployURLSelect().subscribe((data) => this.ClickOnceDeployURLSelect_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ClickOnceDeployURLSelect_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ClickOnceDeployURLSelect_Complete(data: any) {
		this.lstClickOnceDeploy = data;

		if (this.lstClickOnceDeploy.length == 1) {
			this.CAASSAgentDeployUrl = this.lstClickOnceDeploy[0].CAASSAgentDeploy;
			this.RFIDAgentDeployUrl = this.lstClickOnceDeploy[0].RFIDAgentDeploy;
			this.ScanStationDeployUrl = this.lstClickOnceDeploy[0].ScanStationDeploy;
			this.VisitorStationDeployUrl = this.lstClickOnceDeploy[0].VisitorStationDeploy;
			this.CAASSPhotoIDDeployUrl = this.lstClickOnceDeploy[0].CAASSPhotoIDDeploy;
			this.CAASSVisitorIDDeployUrl = this.lstClickOnceDeploy[0].CAASSVisitorIDDeploy;
			this.CAASS10VisitorIDDeployUrl = this.lstClickOnceDeploy[0].CAASS10VisitorIDDeploy;
			this.VPPReceiptDesignerDeployUrl = this.lstClickOnceDeploy[0].VPPReceiptDesignerDeploy;
			this.MultiStationDeployUrl = this.lstClickOnceDeploy[0].MultiStationDeploy;
		}

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onCAASSAgentDeploy
	//
	//-----------------------------------------------------------------------------------------------------

	onCAASSAgentDeploy() {
		window.open(this.CAASSAgentDeployUrl);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRFIDAgentDeploy
	//
	//-----------------------------------------------------------------------------------------------------

	onRFIDAgentDeploy() {
		window.open(this.RFIDAgentDeployUrl);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onScanStationDeploy
	//
	//-----------------------------------------------------------------------------------------------------

	onScanStationDeploy() {
		window.open(this.ScanStationDeployUrl);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onVisitorStationDeploy
	//
	//-----------------------------------------------------------------------------------------------------

	onVisitorStationDeploy() {
		window.open(this.VisitorStationDeployUrl);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onCAASSPhotoIDDeploy
	//
	//-----------------------------------------------------------------------------------------------------

	onCAASSPhotoIDDeploy() {
		window.open(this.CAASSPhotoIDDeployUrl);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onCAASSVisitorIDDeploy
	//
	//-----------------------------------------------------------------------------------------------------

	onCAASSVisitorIDDeploy() {
		window.open(this.CAASSVisitorIDDeployUrl);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onCAASSVisitorIDDeploy
	//
	//-----------------------------------------------------------------------------------------------------

	onCAASS10VisitorIDDeploy() {
		window.open(this.CAASS10VisitorIDDeployUrl);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onMultiStationDeploy
	//
	//-----------------------------------------------------------------------------------------------------

	onMultiStationDeploy() {
		window.open(this.MultiStationDeployUrl);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
